import { Badge, Checkbox, Flex, Text } from '@chakra-ui/react';

export const HEADER_CLASS = 'add-user-licence-tree';

const COL_W = 112;

export const getAvailableQuantity = (item) => {
    if (item.total == null) return null;
    return item.total - (item.active ?? 0);
};

const canAssignLicence = (item) => {
    const available = getAvailableQuantity(item);
    return available == null || available > 0;
};

const hasUnavailableRequiredChild = (item, catalogue, selected) =>
    catalogue.some(
        (child) =>
            child.parentId === item.id &&
            child.required &&
            !selected.has(child.id) &&
            !canAssignLicence(child),
    );

export const canAssignRow = (item, catalogue, selected) =>
    canAssignLicence(item) &&
    !hasUnavailableRequiredChild(item, catalogue, selected);

export const assignCellRenderer = ({ data, context }) => {
    if (!data) return null;
    const isMust = data.required;
    // MUST children are checked when their parent is selected (or already in the selection)
    const parentIsSelected =
        isMust && data.parentId
            ? context.selectedRef.current.has(data.parentId)
            : false;
    const isChecked = isMust
        ? parentIsSelected || context.selectedRef.current.has(data.id)
        : context.selectedRef.current.has(data.id);
    const isUnavailable =
        !isChecked &&
        !canAssignRow(data, context.catalogue, context.selectedRef.current);
    const isDisabled = isMust || isUnavailable;
    return (
        <Flex justify="center" align="center" h="100%">
            <Checkbox
                isChecked={isChecked}
                isDisabled={isDisabled}
                onChange={() => !isDisabled && context.handleToggle(data.id)}
                colorScheme="messenger"
                borderColor={context.darkMode ? 'white' : 'gray.400'}
                mb={0}
            />
        </Flex>
    );
};

const nameInnerRenderer = ({ data, context }) => {
    if (!data) return null;
    return (
        <Flex align="center" gap={2}>
            <Text
                fontSize="sm"
                fontWeight="500"
                color={context.darkMode ? 'white' : 'gray.800'}>
                {data.name}
            </Text>
            {data.required && (
                <Badge
                    colorScheme="messenger"
                    fontSize="9px"
                    lineHeight="normal"
                    textTransform="capitalize">
                    Required
                </Badge>
            )}
        </Flex>
    );
};

export const COLUMN_DEFS = [
    {
        headerName: 'Assign',
        field: 'id',
        width: COL_W,
        maxWidth: COL_W,
        minWidth: COL_W,
        headerClass: HEADER_CLASS,
        sortable: false,
        filter: false,
        resizable: false,
        suppressMovable: true,
        suppressHeaderMenuButton: true,
        suppressHeaderFilterButton: true,
        cellStyle: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        cellRenderer: assignCellRenderer,
    },
    {
        headerName: 'Active',
        field: 'active',
        width: COL_W,
        maxWidth: COL_W,
        minWidth: COL_W,
        headerClass: HEADER_CLASS,
        sortable: false,
        filter: false,
        resizable: false,
        suppressMovable: true,
        suppressHeaderMenuButton: true,
        suppressHeaderFilterButton: true,
        cellStyle: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        valueFormatter: ({ value }) => value ?? 0,
    },
    {
        headerName: 'Available',
        field: 'available',
        width: COL_W,
        maxWidth: COL_W,
        minWidth: COL_W,
        headerClass: HEADER_CLASS,
        sortable: false,
        filter: false,
        resizable: false,
        suppressMovable: true,
        suppressHeaderMenuButton: true,
        suppressHeaderFilterButton: true,
        cellStyle: (params) => ({
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: params.data?.isAtLimit ? '#FC8181' : undefined,
        }),
        valueFormatter: ({ value }) =>
            value !== null && value !== undefined ? value : '—',
    },
];

export const AUTO_GROUP_COL_DEF = {
    headerName: 'Licence',
    flex: 1,
    minWidth: 200,
    sortable: false,
    filter: false,
    resizable: false,
    suppressMovable: true,
    suppressHeaderMenuButton: true,
    suppressHeaderFilterButton: true,
    cellRendererParams: {
        suppressCount: true,
        innerRenderer: nameInnerRenderer,
    },
};

export const DEFAULT_COL_DEF = {};
